import { createSlice } from '@reduxjs/toolkit'

export const simulatorProfilesSlice = createSlice({
    name: 'simulatorProfiles',
    initialState: {
        result: [],
    },
    reducers: {
        setSimulatorProfiles: (state, action) => {
            state.result = action.payload;
        }
    },
})

export const { setSimulatorProfiles } = simulatorProfilesSlice.actions;

export const getSimulatorProfiles = (state) => state.simulatorProfiles.result;

export default simulatorProfilesSlice.reducer